import { IBreadcrumb } from '../components/breadcrumbs'
import { ICategoryPathElement } from '../types/marketplace-categories'
import { generatePathForCategoryIdPath } from './marketplace-categories'

export function createCategoryBreadcrumbs(
  baseBreadcrumbs: IBreadcrumb[],
  basePath: string,
  categoryPath: ICategoryPathElement[] | null | undefined,
  searchParams?: string
): IBreadcrumb[] {
  if (!categoryPath || categoryPath.length === 0) {
    return baseBreadcrumbs
  }

  return [
    ...baseBreadcrumbs,
    ...categoryPath.map((c, idx) => ({
      title: c.title,
      linkTo: {
        pathname: generatePathForCategoryIdPath(
          basePath,
          categoryPath.slice(0, idx + 1).map(cpe => cpe.code)
        ),
        search: searchParams,
      },
    })),
  ]
}

export function createProductListingCategoryBreadcrumbs(
  baseBreadcrumbs: IBreadcrumb[],
  basePath: string,
  categoryPath: ICategoryPathElement[],
  searchParams?: string
): IBreadcrumb[] {
  if (categoryPath.length === 0) {
    return baseBreadcrumbs
  }
  const [lastCategoryPath] = categoryPath.slice(-1)
  const rest = categoryPath.slice(undefined, -1)

  return [
    ...createCategoryBreadcrumbs(baseBreadcrumbs, basePath, rest, searchParams),
    ...(lastCategoryPath
      ? [
          {
            title: lastCategoryPath?.title,
          },
        ]
      : []),
  ]
}

export function createProductSearchBreadcrumbs(query: string): IBreadcrumb[] {
  if (query) {
    return [
      {
        title: 'See all results',
        linkTo: `/search?q=${query}`,
      },
      {
        title: 'Shop all',
        linkTo: `/shop/products?q=${query}`,
      },
    ]
  } else {
    return []
  }
}
